import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=d274b214&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=d274b214&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d274b214",
  null
  
)

export default component.exports